import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useFeedback(role) {
  const [feedback, setFeedback] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchFeedback = useCallback(async () => {
    try {
      let endpoint = '';
      if (role === 'student') endpoint = '/student/counselor-feedback';
      else if (role === 'parent') endpoint = '/parent/counselor-feedback';
      else if (role === 'teacher') endpoint = '/teacher/counselor-feedback';
      else if (role === 'counselor') endpoint = '/counselor/sent-feedback';
      else return;

      const res = await axios.get(`${API}${endpoint}`);
      const list = res.data.feedback || [];
      setFeedback(list);
    } catch {
      /* silent */
    } finally {
      setLoading(false);
    }
  }, [role]);

  useEffect(() => {
    fetchFeedback();
  }, [fetchFeedback]);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (!userId || role === 'counselor') {
      setUnreadCount(0);
      return;
    }
    const count = feedback.filter(fb => !fb.read_by?.includes(userId)).length;
    setUnreadCount(count);
  }, [feedback, role]);

  const markAsRead = useCallback(async (feedbackId) => {
    try {
      await axios.put(`${API}/counselor-feedback/${feedbackId}/mark-read`);
      setFeedback(prev =>
        prev.map(fb => fb.id === feedbackId
          ? { ...fb, read_by: [...(fb.read_by || []), localStorage.getItem('userId')] }
          : fb
        )
      );
    } catch {
      /* silent */
    }
  }, []);

  return { feedback, unreadCount, loading, refetch: fetchFeedback, markAsRead };
}
